<template lang="pug">
  .rooms
    .breadcrumbs
      h2 Create a Setting
      SettingForm(:saving='saving' @save='save')
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { sdk } from '@/graphql/client'
import SettingForm from './Form.vue'

@Component({ components: { SettingForm } })
export default class createSetting extends Vue {
  saving = false
  async save (payload) {
    this.saving = true
    await sdk.CreateSetting({ setting: payload })
    this.saving = false
    this.$router.push({
      name: 'settings'
    })
  }
}
</script>

<style lang="scss" scoped>
.breadcrumbs {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 2rem;
}
.actions {
  margin-bottom: 20px;
  text-align: right;
}
</style>

<style lang="scss">
.filepond--item {
  width: 50%;
}
</style>
